const apiAccess = {
  apiAccess: {
    apiAccessTitle: 'Accès API',
    apiAppContent:
      'Avec l’API des systèmes Enlighten, les développeurs de logiciel peuvent écrire des applications externes lisant les données de production du système. Ces applications peuvent vous demander de saisir un identifiant utilisateur afin d’effectuer des demandes API pour votre compte. Votre identifiant utilisateur est %{user_id}.',
    showApp: 'Afficher les applications qui ont un accès API',
    isGrantedApp: 'Vous n’avez accordé l’accès API à aucune application.',
    apiSystemContent:
      'Une application externe ne peut récupérer les données des systèmes que si l’accès API est autorisé. Cet accès est contrôlé par le propriétaire du système. Si vous pouvoir voir un système mais qu’il n’est pas listé ici, c’est que le propriétaire a choisi de ne pas lui accorder l’accès API.',
    showSystem: 'Montrer les systèmes qui autorisent l’accès API',
    isGrantedSystem: 'Vous n’avez accordé l’accès API à aucun système.',
    revokeAccess: 'Annuler l’accès'
  }
};

export default apiAccess;
